<div class="pe-2 ps-2"></div>
<ul class="navbar-nav me-auto">
  @if (PermissionsType.VIEW_INVENTORY | hasPermission) {
    <li
      class="nav-item" [class.active]="section === 'inventory'">
      <a class="nav-link" href="javascript:void(0);"
        [id]="'tab-inventory' + idSuffix"
        (click)="handleClickTabs($event, 'inventory')">
        Inventory
        <span class="newApp badge">{{ numberNewApps }}</span>
      </a>
    </li>
  }
  @if (!(PermissionsType.VIEW_INVENTORY | hasPermission)) {
    <li
      class="nav-item" [class.active]="section === 'my-apps'">
      <a class="nav-link" href="javascript:void(0);"
        [id]="'tab-my-apps' + idSuffix"
        (click)="handleClickTabs($event, 'my-apps')">
        My Apps
      </a>
    </li>
  }
  @if (PermissionsType.MANAGE_APP | hasPermission) {
    <li
      class="nav-item" [class.active]="section === 'publish'">
      <a class="nav-link" href="javascript:void(0);"
        [id]="'tab-publish' + idSuffix"
        (click)="handleClickTabs($event, 'publish')">
        Manage Apps
      </a>
    </li>
  }
  @if (PermissionsType.ACCESS_MYAMADEUS_TROUBLESHOOTING | hasPermission) {
    <li
      class="nav-item" [class.active]="section === 'troubleshooting'">
      <a class="nav-link" href="javascript:void(0);"
        [id]="'tab-troubleshooting' + idSuffix"
        (click)="handleClickTabs($event, 'troubleshooting')">
        Troubleshooting
      </a>
    </li>
  }
  @if (PermissionsType.VIEW_URL | hasPermission) {
    <li
      class="nav-item" [class.active]="section === 'manage-urls'">
      <a class="nav-link" href="javascript:void(0);"
        [id]="'tab-manage-urls' + idSuffix"
        (click)="handleClickTabs($event, 'manage-urls')">
        Manage URLs
      </a>
    </li>
  }
</ul>
@if (!(PermissionsType.MANAGE_MARKET_CATALOG | hasPermission) ||
  (PermissionsType.VIEW_INVENTORY | hasPermission)) {
  <ama-ng-search
    [idSuffix]=idSuffix
    (searchTriggered)="onSearch()"
  ></ama-ng-search>
}
